import React from 'react';
import PropTypes from 'prop-types';
import URL from 'url-parse';

import ShareWhatsApp from '~/src/components/svg/action/ShareWhatsApp';
import {withTypeContext} from '~/src/components/context/TypeContext';

import {sendShareRequest} from '~/src/utilities/feed/activity.js';
import {BeagleEvents, GtmEvents, InteractionSources} from '~/src/utilities/constants/tracking';
import initPolyglot from '~/src/utilities/libs/polyglot';
import {TeaserTypes, ContentType, SharePlatformTypes} from '~/src/utilities/constants/types';
import {Asset} from '~/src/utilities/constants/asset';
import {trackGtm} from '~/src/utilities/tracking/gtm';

import css from './WhatsAppShare.module.scss';
import i18nStrings from './WhatsAppShare.i18n.json';

const getTranslation = initPolyglot(i18nStrings);

class WhatsAppShare extends React.Component {
    getHref = () => {
        const url = new URL(this.props.url);
        const text = getTranslation('shareText', {
            title: this.props.title,
            lead: this.props.lead,
            url: url.href
        });

        return `https://wa.me/?text=${encodeURIComponent(text)}`;
    };

    handleClick = () => {
        const beagleEvent =
            this.props.context.type === TeaserTypes.VIDEOS || this.props.context.type === ContentType.VIDEO
                ? BeagleEvents.VIDEO_SHARE
                : BeagleEvents.STORY_SHARE;
        sendShareRequest(this.props.metadataId, beagleEvent, Asset.STORY, SharePlatformTypes.WHATSAPP);

        trackGtm(GtmEvents.INTERACTION, {
            interactionSource: InteractionSources.SHARE_OVERLAY,
            interactionType: GtmEvents.SHARE_WHATSAPP
        });
    };

    render() {
        return (
            <a className={css.whatsAppShare} onClick={this.handleClick} href={this.getHref()}>
                <span className={css.shareLogo}>
                    <ShareWhatsApp title={getTranslation('shareWithWhatsApp')} />
                </span>
                <div>{getTranslation('shareWithWhatsApp')}</div>
            </a>
        );
    }
}

if (process.env.NODE_ENV === 'development') {
    WhatsAppShare.propTypes = {
        metadataId: PropTypes.string.isRequired,
        lead: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired
    };
}

export default withTypeContext(WhatsAppShare);
